module.exports = __webpack_public_path__ + "static/media/banner.0899c0a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageBrain/banner.png
// module id = 655
// module chunks = 0